import { Controller } from "@hotwired/stimulus"

export default class PopupWindowController extends Controller {
  open(event) {
    window.open("", event.params.name, this.#features())
  }

  #features() {
    const width = 600
    const height = 720
    const left = window.screenX + (window.outerWidth - width) / 2
    const top = window.screenY + (window.outerHeight - height) / 2
    return `popup,width=${width},height=${height},left=${left},top=${top}`
  }
}
